/**************************************************************************************
 *  Objetivo: Page Mapas
 *  Autor: Luiz Gustavo
 *  Data: 12/01/2023
 *  Versão: 1.0
 **************************************************************************************/

import ContainerMapas from '../../components/ContainerMapas';
import '../../css/mapas.css'

function Mapas() {
  return (
    <div className="mapas">
      <h1 className="titulo-mapas">Mapas</h1>
      <ContainerMapas />
    </div> 
  );
}

export default Mapas;
